import { styled } from '@mui/material/styles';

export const BarCodeCanvas = styled('canvas')(({ theme }) => ({
	width: '100%',
	height: '100%',
	backgroundColor: theme.palette.common.white,
}));
